module.exports = __webpack_public_path__ + "img/mcgl_tyg_02.34be512f.png";